module.exports = __webpack_public_path__ + "static/media/carriedSpreader.d7deae73.png";